import React from "react";
import { BigNumber } from "ethers";

export type VestingContextValue = {
  vestingAmountInBearsRemaining?: Record<number, BigNumber>;
  vestingAmountInBearsRemainingSum?: BigNumber;
  readVestingAmountRemainingInBears: () => void;
  vestingAmountInJarsRemaining?: Record<number, BigNumber>;
  vestingAmountInJarsRemainingSum?: BigNumber;
  readVestingAmountRemainingInJars: () => void;
  vestingAmountRemaining?: BigNumber;
};

const VestingContext = React.createContext<VestingContextValue>({
  readVestingAmountRemainingInBears: () => {},
  readVestingAmountRemainingInJars: () => {},
});

export default VestingContext;
